var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1224 11.25C11.2408 11.25 10.4384 11.6016 9.84605 12.1781L6.46071 10.016C6.6639 9.35508 6.6639 8.64141 6.46071 7.98398L9.84605 5.82188C10.4384 6.39844 11.2408 6.75 12.1224 6.75C13.9477 6.75 15.4286 5.23828 15.4286 3.375C15.4286 1.51172 13.9477 0 12.1224 0C10.2972 0 8.81633 1.51172 8.81633 3.375C8.81633 3.71953 8.86798 4.06406 8.96786 4.39102L5.58253 6.55312C4.99018 5.97656 4.18776 5.625 3.30612 5.625C1.48087 5.625 0 7.13672 0 9C0 10.8633 1.48087 12.375 3.30612 12.375C4.18776 12.375 4.99018 12.0234 5.58253 11.4469L8.96786 13.609C8.86798 13.9395 8.81633 14.2805 8.81633 14.625C8.81633 16.4883 10.2972 18 12.1224 18C13.9477 18 15.4286 16.4883 15.4286 14.625C15.4286 12.7617 13.9477 11.25 12.1224 11.25ZM12.1224 1.6875C13.0351 1.6875 13.7755 2.44336 13.7755 3.375C13.7755 4.30664 13.0351 5.0625 12.1224 5.0625C11.2098 5.0625 10.4694 4.30664 10.4694 3.375C10.4694 2.44336 11.2098 1.6875 12.1224 1.6875ZM3.30612 10.6875C2.39349 10.6875 1.65306 9.93164 1.65306 9C1.65306 8.06836 2.39349 7.3125 3.30612 7.3125C4.21875 7.3125 4.95918 8.06836 4.95918 9C4.95918 9.93164 4.21875 10.6875 3.30612 10.6875ZM12.1224 16.3125C11.2098 16.3125 10.4694 15.5566 10.4694 14.625C10.4694 13.6934 11.2098 12.9375 12.1224 12.9375C13.0351 12.9375 13.7755 13.6934 13.7755 14.625C13.7755 15.5566 13.0351 16.3125 12.1224 16.3125Z",
    fill: "#FCA905"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4286,
    height: 18,
    fill: "#FCA905"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5f0385fb.svg";
export { ForwardRef as ReactComponent };